import { Injectable } from '@angular/core';
import { first } from 'lodash-es';
import { LANGUAGE } from 'shared-components';
import { TranslationService } from '../internationalization/translation.service';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  readonly defaultLocaleId = LANGUAGE.ENGLISH_CANADA;
  readonly localeIdDelimiter = '-';

  constructor(private readonly translationService: TranslationService,) {
  }

  public isEngLocale(): boolean {
    return this.getLocaleCode().indexOf('en') >= 0 || this.getLocaleCode().toLowerCase() === 'zz';
  }

  public getLocaleCode(): string {
    const currentLang = this.translationService.getCurrentLanguage();
    return first((currentLang ?? this.defaultLocaleId).split(this.localeIdDelimiter)) ?? '';
  }
}
